module.exports = __webpack_public_path__ + "static/media/prosocialcommerce-logo.54ff618d.svg";